module.exports = __webpack_public_path__ + "static/6242c13350d400db15db5e673b30a729368b98a7da3628f169b875931dc17b61-b5a6d052e9c9dbe5e43a878f40099c15.png";